import React from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import BlogGenerator from "./MarketingAgentBlogGenerator"; // Import animation wrapper
import BlogInputForm from "./MarketingAgentBlogInputForm"; // Import animation wrapper
import "./MarketingAgent.css"; // Import the CSS file


const MarketingAgent = () => {
  return (
    <FadeInSection className="marketing-agent-container">

        <img
          src={`${process.env.PUBLIC_URL}/core_docs_agent.svg`} 
          alt="Core Docs Agents" 
          className="agent-image"
        />

      <h2 className="marketing-agent-title">Core Docs Agent</h2>

      <p className="marketing-agent-description">
        Every organization relies on essential documents—whether for strategy, communication, or planning. The Core Docs Agent automates the creation of critical materials like product requirement documents, pitch decks, one-pagers, website copy, and marketing emails, ensuring consistency and efficiency.
      </p>

      <div className="marketing-agent-grid">
        {/* Benefit 1 */}
        <div className="marketing-agent-item">
          <h3 className="marketing-agent-subtitle">Third-Party API Integration</h3>
          <p className="marketing-agent-text">
            Pulls insights from external data sources and internal knowledge bases to generate context-aware documents.
          </p>
        </div>

        {/* Benefit 2 */}
        <div className="marketing-agent-item">
          <h3 className="marketing-agent-subtitle">Automated Document Creation</h3>
          <p className="marketing-agent-text">
           Produces high-quality drafts for PRDs, blogs, marketing materials, investor decks, and more—ready for refinement or immediate use.
          </p>
        </div>

        {/* Benefit 3 */}
        <div className="marketing-agent-item">
          <h3 className="marketing-agent-subtitle">Seamless Integration</h3>
          <p className="marketing-agent-text">
            Works within your existing workflow or as a standalone tool for streamlined document creation and management.
          </p>
        </div>
      </div>

    <BlogGenerator />

    </FadeInSection>
  );
};

export default MarketingAgent;
